import { Heading } from '@coingate/ui/dist/components/Typography';

import { GIFT_CARDS_LINK, MERCHANT_DIRECTORY_LINK } from '../../constants';

const RightPaneContent = () => {
  return (
    <div className="flex flex-col gap-9">
      <div className="flex flex-col gap-4">
        <Heading.H2 className="text-xl m-0">
          <span className="bg-gradient-purple-fade bg-clip-text text-transparent">
            Unlock crypto
          </span>{' '}
          <span className="text-gray-900">for your business</span>
        </Heading.H2>

        <div className="flex flex-col gap-2">
          <div className="flex flex-row gap-2">
            <img src="/status-icon-completed-blue.svg" />
            <div className="text-sm font-normal text-grey-600">
              Accept crypto globally. Fees from 1%.
            </div>
          </div>

          <div className="flex flex-row gap-2">
            <img src="/status-icon-completed-blue.svg" />
            <div className="text-sm font-normal text-grey-600">
              Send crypto effortlessly: single or bulk payouts worldwide.
            </div>
          </div>

          <div className="flex flex-row gap-2">
            <img src="/status-icon-completed-blue.svg" />
            <div className="text-sm font-normal text-grey-600">
              Deposit, hold, convert, withdraw securely.
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col gap-4">
        <div className="text-sm font-normal text-gray-600">
          Trusted by 500+ companies
        </div>

        <img src="/companies.svg" />
      </div>

      <div>
        <div className="text-sm font-normal text-gray-600">
          <span>Not interested in a business account? Buy</span>{' '}
          <a
            className="text-gray-600 underline hover:text-gray-600 hover:no-underline"
            data-test="gift-cards-link"
            target="_blank"
            rel="noreferrer"
            href={GIFT_CARDS_LINK}
            onClick={(e) => e.stopPropagation()}
          >
            CoinGate gift cards
          </a>{' '}
          <span>or find where you can spend crypto in our</span>{' '}
          <a
            className="text-gray-600 underline hover:text-gray-600 hover:no-underline"
            data-test="merchant-directory-link"
            target="_blank"
            rel="noreferrer"
            href={MERCHANT_DIRECTORY_LINK}
            onClick={(e) => e.stopPropagation()}
          >
            Merchant directory
          </a>{'.'}
        </div>
      </div>
    </div>
  )
}

export default RightPaneContent
